import React, {useContext, useEffect, useState} from 'react';
import ReactModal from "react-modal";
import axios from "axios";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import {UserContext} from "./components/UserContext";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import {getBearerToken, getServerUrl} from "./components/utils/utils";

function TagFriendsModal({tripId, open, onClose, tripOwnerId}) {
    const { user } = useContext(UserContext)
    const [friends, setFriends] = useState([])
    const [taggedFriends, setTaggedFriends] = useState([])

    const fetchFriends = async () => {
        axios.get(`${getServerUrl()}/friends`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setFriends(response.data.filter(friend => friend.status === 'ACCEPTED'))
            })
    }

    const fetchTaggedUsers = async () => {
        axios.get(`${getServerUrl()}/trip/${tripId}/taggedUsers`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTaggedFriends(response.data)
            })
    }

    useEffect(() => {
        if (open) {
            fetchFriends()
        }

    }, [open])

    useEffect(() => {
        if (open) {
            fetchTaggedUsers()
        }
    }, [open, tripId])

    const clearState = () => {
        setTaggedFriends([])
    }

    const deleteUserTag = async taggedUserId => {
        axios.delete(`${getServerUrl()}/taggedUser/${taggedUserId}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(() => {
                setTaggedFriends(taggedFriends.filter(taggedFriend => taggedFriend.id !== taggedUserId))
            })
    }

    const tagUser = async userId => {
            axios.post(`${getServerUrl()}/trip/${tripId}/tagUser/${userId}`, {}, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                    Authorization: `Bearer ${await getBearerToken()}`
                }
            }).then(response => {
                setTaggedFriends([...taggedFriends, response.data])
            });
    }

    const displayFriendsList = () => friends.filter(friendObj => friendObj.friend.id !== tripOwnerId).map(friendObj => {
        const friend = friendObj.friend
        const taggedFriend = taggedFriends.find(taggedFriend => taggedFriend.user.id === friend.id)
        let userAction = null;
        if (taggedFriend?.status === 'ACCEPTED') {
            userAction = <Button onClick={() => deleteUserTag(taggedFriend.id)}>
                Tagged
            </Button>
        } else if (taggedFriend?.status === 'PENDING') {
            userAction = <Button onClick={() => deleteUserTag(taggedFriend.id)}>
                PENDING
            </Button>
        } else {
            userAction = <Button onClick={() => tagUser(friend.id)}>
                Tag Friend
            </Button>
        }
        return (
        <Card sx={{ maxWidth: 345 }}>
            <CardHeader
                avatar={
                    <Avatar sx={{width: 75, height: 75}} src={friend.profilePictureUrl}/>
                }
                action={
                    userAction
                }
                title={friend.username}
            />
        </Card>
    )})

    return (
        <ReactModal isOpen={open} id="tag-friends-modal">
            <h1>Tag friends</h1>
            <div className="exit-button">
                <CancelPresentationIcon sx={{fontSize: 40}} onClick={() => {
                    onClose()
                    clearState()
                }}/>
            </div>
            <div className="friends-list">
                {displayFriendsList()}
            </div>
        </ReactModal>
    )
}

export default TagFriendsModal;